import { loadState } from 'utils/localStorage';

export default () => {
  const { session = {} } = loadState();
  const { token } = session;

  return token;
};
